import { render, staticRenderFns } from "./card-list.vue?vue&type=template&id=5fb16b9a&scoped=true"
import script from "./card-list.vue?vue&type=script&lang=js"
export * from "./card-list.vue?vue&type=script&lang=js"
import style0 from "./card-list.vue?vue&type=style&index=0&id=5fb16b9a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb16b9a",
  null
  
)

export default component.exports